/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { PurOrdDivisionTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const purOrdDivisionFetchListLoading = (state, { boolean }) => ({
  ...state,
  isLoading: boolean
});

export const purOrdDivisionFetchListSuccess = (state, { data }) => ({
  ...state,
  data
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [PurOrdDivisionTypes.PUR_ORD_DIVISION_FETCH_LIST_LOADING]: purOrdDivisionFetchListLoading,
  [PurOrdDivisionTypes.PUR_ORD_DIVISION_FETCH_LIST_SUCCESS]: purOrdDivisionFetchListSuccess
});
